import React from "react";
import {
  Box,
  Button,
  Container,
  Grid,
  makeStyles,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import { theme } from "../constants/theme";
import CssBaseline from "@material-ui/core/CssBaseline";
import {
  GeneralModal,
  SortButtonAndMenu,
  ImageUploadPreview,
} from "../components-molecules";
import { BannersList } from "../components-organisms";
import { HeaderWithButtons } from "../components-molecules";
import { getSubcategoriesSymbolsWithParams } from "../redux/actions/getSubcategories";
import { useDispatch, useSelector } from "react-redux";
import searchicon from "../assets/icons/searchicon.png";
import { useEffect } from "react";
import {
  addNewBanner,
  getBannersSymbols,
  getBannersSymbolsWithParams,
} from "../redux/actions/getBanners";
import { getCollectionsSymbols } from "../redux/actions/getCollections";
// import { setError } from "../redux/actions/error";
const placeholderImage =
  "https://images.unsplash.com/photo-1591871937573-74dbba515c4c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxleHBsb3JlLWZlZWR8NHx8fGVufDB8fHx8&w=1000&q=80";
const PromotionalBanners = (props: any) => {
  const classes = useStyles();
  const [sortType, setSortType] = React.useState("Asc");
  const [newBannerName, setNewBannerName] = React.useState("");
  const [newBannerSubtitle, setNewBannerSubtitle] = React.useState("");
  const [nameError, setNameError] = React.useState(false);
  const [openSearch, setOpenSearch] = React.useState(false);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [previewImageUrl, setPreviewImageUrl] = React.useState("");
  const [image, setImage] = React.useState<string | Blob | null>();
  const [selectedCollection, setSelectedCollection] = React.useState<any>();
  const dispatch = useDispatch();
  const [openAddShopModal, setAddOpenShopModal] =
    React.useState<boolean>(false);

  const bannersData = useSelector(
    (state: any) => state.BannerSymbolsReducer.data
  );

  const collectionsData = useSelector((state: any) => {
    const collectionsList = state.CollectionSymbolsReducer.data;
    let collArr: any = [];
    collectionsList.forEach((element: any) => {
      if (element[1]?.length > 0) {
        collArr = [...collArr, ...element[1]];
      }
    });
    return collArr;
  });

  useEffect(() => {
    dispatch(getBannersSymbols());
    dispatch(getCollectionsSymbols());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(
      getBannersSymbolsWithParams(
        searchTerm ? searchTerm : "",
        sortType.trim() === "" ? "Asc" : sortType,
        null
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortType]);

  const handleSubmit = () => {
    if (newBannerName.trim() === "") {
      setNameError(true);
      return;
    }
    if (!image) return;
    const body = new FormData();

    body.append(
      "json",
      JSON.stringify({
        Title: newBannerName,
        SubTitle: newBannerSubtitle,
        CollectionId: selectedCollection.Id,
      })
    );
    body.append("", image);

    dispatch(
      addNewBanner(body, null, () => {
        // set banner title and subtitle empty
        setAddOpenShopModal(false);
      })
    );
  };

  const bottomTextCreator = React.useCallback((item: any) => {
    return `${item?.SubTitle ? item.SubTitle : ""}`;
  }, []);

  const topTextCreator = React.useCallback(
    (item: any) => `${item?.Title ?? "Unnamed Banner"}`,
    []
  );

  const imagePreviewCreator = (item: any) => item?.ImageUrl ?? placeholderImage;

  function debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  }

  const debounceFunction = (st: string, order: string) =>
    debounce(() => {
      dispatch(getSubcategoriesSymbolsWithParams(st ? st : "", order, null));
    }, 300);

  const performSearch = React.useCallback(
    debounceFunction,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    performSearch(event.target.value, sortType);
  };

  const updateList = ({ search, order, filter }) => {
    dispatch(getBannersSymbolsWithParams(search ? search : "", order, null));
  };

  return (
    <Box className={classes.container}>
      <CssBaseline />
      <Container className={classes.root}>
        <CssBaseline />
        <HeaderWithButtons>
          <HeaderWithButtons.ButtonArea>
            <div className={classes.mgLeftAuto}>
              <SortButtonAndMenu
                menuItems={[
                  {
                    title: "Alphabetical ascending",
                    value: "Asc",
                    handleSelect: () => {
                      setSortType("Asc");
                      updateList({
                        search: "",
                        order: "Asc",
                        filter: null,
                      });
                    },
                  },
                  {
                    title: "Alphabetical descending",
                    value: "Desc",
                    handleSelect: () => {
                      setSortType("Desc");
                      updateList({
                        search: "",
                        order: "Desc",
                        filter: null,
                      });
                    },
                  },
                ]}
                selectedSortType={sortType}
              />
              <Button
                id="basic-button"
                aria-controls="basic-menu"
                aria-haspopup="true"
                onClick={() => setOpenSearch(true)}
              >
                <img
                  src={searchicon}
                  className={classes.buttonIcon}
                  alt="printIcon"
                />
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setAddOpenShopModal(true);
                }}
                style={{ paddingLeft: props.loading ? "12px" : "16px" }}
              >
                Add Banner
              </Button>
            </div>
          </HeaderWithButtons.ButtonArea>
        </HeaderWithButtons>
        {/* CSS FIX : margin-left: auto */}

        {openSearch && (
          <Grid container className={classes.searchBarArea}>
            <Grid item xs={11}>
              <TextField
                style={{ width: "100%" }}
                variant="outlined"
                name="Search"
                placeholder="Search Subcategory"
                label="Search"
                value={searchTerm}
                onChange={handleSearch}
              ></TextField>
            </Grid>
            <Grid item xs={1} className={classes.searchCancelButtonArea}>
              <Button
                id="basic-button"
                aria-controls="basic-menu"
                aria-haspopup="true"
                onClick={() => {
                  setSearchTerm("");
                  setOpenSearch(false);
                }}
                className={classes.modalImageText}
              >
                {/* <img src={printIcon} className={classes.buttonIcon} alt="printIcon" /> */}
                <Typography
                  variant="button"
                  component="span"
                  color="primary"
                  className={classes.printButtonText}
                  onClick={() => {
                    setSearchTerm("");
                    updateList({
                      search: "",
                      order: sortType,
                      filter: null + "",
                    });
                  }}
                >
                  Cancel
                </Typography>
              </Button>
            </Grid>
          </Grid>
        )}

        <BannersList
          data={
            bannersData
              ? bannersData.sort((a, b) => {
                  if (a[0]) return -1;
                  else return 1;
                })
              : []
          }
          bottomTextCreator={bottomTextCreator}
          topTextCreator={topTextCreator}
          imagePreviewCreator={imagePreviewCreator}
          pathCreator={(item: any) => `/admin/banner/${item.Id}`}
        />
      </Container>
      <GeneralModal
        title="Add Promotional Banner"
        description="Start by giving category a name, upload an image and write a short description.Once added you will be able to add subSubcategorys from Subcategorys details screen."
        visible={openAddShopModal}
        onClose={setAddOpenShopModal}
        onSubmit={handleSubmit}
        modalWidth="560px"
      >
        <GeneralModal.ContentArea>
          <Grid container>
            <Grid item container xs={12}>
              <Grid item xs={3}>
                <ImageUploadPreview
                  onChange={(file: any) => {
                    setImage(file);
                    setPreviewImageUrl(URL.createObjectURL(file));
                  }}
                  iconAreaHeight={15}
                  containerHeight={120}
                  previewImageUrl={previewImageUrl}
                  containerWidth={120}
                  iconHeight="15"
                  iconWidth="15"
                />{" "}
              </Grid>
              <Grid item xs={9} className={classes.modalImageTextArea}>
                <Typography
                  variant="body2"
                  component="span"
                  color="textSecondary"
                  className={classes.modalImageText}
                >
                  Square image with 300px x 300px resolution transparent
                  background works best
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              {/* Banner Title */}
              <TextField
                placeholder="Banner Name"
                value={newBannerName}
                variant="outlined"
                margin="normal"
                fullWidth
                id="BannerName"
                label="Banner Name"
                name="BannerName"
                onChange={(event: any) => setNewBannerName(event.target.value)}
                error={nameError}
                InputProps={{
                  classes: {
                    root: classes.cssOutlinedInput,
                    focused: classes.cssFocused,
                    notchedOutline: classes.notchedOutline,
                  },
                }}
              />
              {/* Banner Subtitle */}
              <TextField
                placeholder="Banner Subtitle"
                value={newBannerSubtitle}
                variant="outlined"
                margin="normal"
                fullWidth
                id="BannerSubtitle"
                label="Banner Subtitle"
                name="BannerSubtitle"
                onChange={(event: any) =>
                  setNewBannerSubtitle(event.target.value)
                }
                error={nameError}
                InputProps={{
                  classes: {
                    root: classes.cssOutlinedInput,
                    focused: classes.cssFocused,
                    notchedOutline: classes.notchedOutline,
                  },
                }}
              />
              {/* Select Collection */}
              <FormControl variant="outlined" className={classes.selectArea}>
                <InputLabel id="demo-simple-select-outlined-label">
                  Collection
                </InputLabel>
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  value={selectedCollection?.Id}
                  disabled={props?.Vertical ? true : false}
                  onChange={(event: any) => {
                    // Should select from collection list
                    setSelectedCollection(
                      collectionsData.find(
                        (i: any) => i.Id === event.target.value
                      )
                    );
                    //setSelectedVertical();
                  }}
                  label="Collection"
                >
                  {/* CollectionList  */}
                  {collectionsData.map((v: any, index: number) => (
                    <MenuItem key={index} value={v.Id}>
                      {v.Name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </GeneralModal.ContentArea>
        <GeneralModal.ButtonArea>
          <Button
            onClick={() => {
              setAddOpenShopModal(false);
            }}
            className={classes.cancelButton}
          >
            <Typography
              onClick={() => {
                setNameError(false);
                setNewBannerName("");
                setAddOpenShopModal(false);
              }}
              variant="button"
              component="p"
              color="primary"
            >
              Cancel
            </Typography>
          </Button>
          <Button onClick={handleSubmit} className={classes.submitButton}>
            <Typography variant="button" component="p" color="inherit">
              Submit
            </Typography>
          </Button>
        </GeneralModal.ButtonArea>
      </GeneralModal>
    </Box>
  );
};

const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "center",
  },
  buttonIcon: {
    width: "18px",
    height: "18px",
    marginRight: 8,
  },
  root: {
    flexGrow: 1,
    maxWidth: "840px",
  },
  tabContainer: {
    backgroundColor: theme.palette.background.paper,
    paddingBottom: "8px",
  },
  mgLeftAuto: {
    display: "flex",
    flexDirection: "row",
  },
  submitButton: {
    width: "80px",
    height: "48px",
    borderRadius: "8px",
    padding: "6px 16px",
    backgroundColor: theme.palette.primary.main,
    color: "white",
  },
  cancelButton: {
    width: "80px",
    height: "48px",
    borderRadius: "8px",
    padding: "6px 16px",
    backgroundColor: theme.palette.primary.light,
    marginRight: "8px",
  },
  cssOutlinedInput: {
    display: "flex",
    "&$cssFocused $notchedOutline": {
      border: `1px solid ${theme.palette.primary.main}`,

    },
  },

  cssFocused: {},

  notchedOutline: {
    border: "1px solid rgba(0, 0, 0, 0.12)",
  },
  modalImageText: { display: "inline-block", verticalAlign: "middle" },
  modalImageTextArea: { display: "flex", alignItems: "center" },
  printButtonText: {
    textTransform: "none",
  },
  searchCancelButtonArea: {
    display: "flex",
    alignItems: "center",
  },
  searchBarArea: {
    marginTop: 25,
  },
  selectArea: { width: "100%", marginBottom: 15 },
});

export default PromotionalBanners;
